import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-element-event-sign";
const container = objectWithClassName({
  className: `${classNamePrefix}-container`,
  display: "flex",
  alignItems: "center",
  "& *": {
    display: "block",
    textTransform: "uppercase",
    textAlign: "center",
    maxWidth: "200px",
    fontWeight: "700"
  }
});
export {
  container
};
//# sourceMappingURL=sign.js.map
